import React from 'react';

const CARDS = [
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
    title: 'Global Staffing Firms',
    body:  'Quote contractor placements in multiple countries with full statutory cost visibility. Win mandates with numbers your competitors can\'t match.',
  },
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>,
    title: 'EOR & AOR Providers',
    body:  'Price employer-of-record and agent-of-record engagements accurately. Know your true cost exposure before you sign the contract.',
  },
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
    title: 'Recruitment Agencies',
    body:  'Add a cost intelligence layer to your recruitment advisory. Show clients the real difference between placements in Japan, Norway, and the Netherlands.',
  },
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
    title: 'Corporate HR & Finance Teams',
    body:  'Budget contractor headcount across geographies with confidence. Replace spreadsheet guesswork with structured, auditable cost breakdowns.',
  },
];

export default function Audience() {
  return (
    <section className="audience" id="audience">
      <div className="container">
        <div className="section-label">Who uses Quoteology</div>
        <h2 className="section-title">Built for the global placement industry</h2>
        <div className="audience-grid">
          {CARDS.map(c => (
            <div className="audience-card" key={c.title}>
              <div className="audience-icon">{c.icon}</div>
              <h4>{c.title}</h4>
              <p>{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
